import Pic from '../assets/Luffy.jpg'; // Adjust the path based on your folder structure

export const Arafat = () => {
  return (
    <div>
      <h1>About Me</h1>
      <img src={Pic} alt="Arafat" style={{ width: "150px", borderRadius: "50%" }} />
      <p style={{ textAlign: "center", margin: "20px 0" }}>
      Hello, I'm Arafat, a senior majoring in Computer Science with a minor in Psychology. I have a strong passion for front-end development, where I enjoy crafting user-friendly and visually appealing web experiences. Beyond coding, I'm a huge football fan, especially when it comes to Manchester United. Watching United play has been a big part of my life, and my admiration for Cristiano Ronaldo only adds to that passion.

      </p>
    </div>
  );
};